import { render } from "./MyProjects.vue?vue&type=template&id=0d894f95&ts=true"
import script from "./MyProjects.vue?vue&type=script&lang=ts"
export * from "./MyProjects.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__